export default __webpack_public_path__ + "static/media/purpleGcp.833be8e7.svg";